import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DayOfWeekSelectorComponent } from '../day-of-week-selector/day-of-week-selector.component';
import { TimeWithTimeZoneSelectorComponent } from '../time-with-time-zone-selector/time-with-time-zone-selector.component';
import { ScheduleTime, WeeklySchedule } from '@mode/shared/schedules/contract';

@Component({
  standalone: true,
  imports: [CommonModule, DayOfWeekSelectorComponent, TimeWithTimeZoneSelectorComponent],
  selector: 'mode-weekly-schedule-config',
  templateUrl: './weekly-schedule-config.component.html',
  styleUrls: ['./weekly-schedule-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeeklyScheduleConfigComponent {
  @Input() schedule: WeeklySchedule = {
    hour: 0,
    minute: 0,
    dayOfTheWeek: 'Monday',
    timeZone: 'UTC',
    frequency: 'weekly',
  };
  @Output() dayOfWeekChanged = new EventEmitter<number>();
  @Output() timeChanged = new EventEmitter<ScheduleTime>();
}
